import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

import { hideDialog } from '../../actions/index';
import NeuriteGrid from '../../components/neurite_grid';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import { getData } from '../../dataLib';

//components
import FloatNumberFormatInput from '../../components/float_number_input_formatter';

const styles = theme => ({
    root: {
        margin: theme.spacing(2)
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    Typography: {
        margin: 'auto'
    },
    total: {
        display: 'flex',
        fontWeight: '500',
        textTransform: 'capitalize',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: 200,
        margin: '30px 8px 20px 0',
    },
    inputImporte: {
        textAlign: 'right',
        margin: 8,
        padding: 0,
        fontSize: 12,
    },
    input: {
        width: 80,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class CierreSemanalResumenMKT extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mkt: [],
            total: 0.0
        }
    }

    getMKT = () => {
        getData('VMKT/MKTSemana?centro_id=' + this.props.centroDiaSelected.centro.id + '&date=' + this.props.centroDiaSelected.dia,
            (response) => {
                this.setState({ ...this.state, mkt: response.data, total: this.calculateTotal(response.data) })
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching mkt'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );
    }

    calculateTotal = (rows) => {
        let total = 0.0;
        rows.forEach((r) => {
            total += parseFloat(r.importe);
        })

        return total;
    }

    componentDidMount = () => {
        this.getMKT();
    }

    render() {
        const { classes } = this.props;

        if (this.state.mkt.length === 0) {
            return (<div>
                <div className={classes.bottomBtn}>
                    <Button variant="contained" color="secondary" className={classes.button} onClick={() => { this.props.hideDialog() }}>Atrás</Button>
                </div>
            </div>);
        }

        return (
            <div className={classes.root}>
                <NeuriteGrid
                    id="c_s_r_m"
                    columns={[
                        { key: 'fecha', name: 'Fecha', editable: false, dragable: false, type: 'date', width: 80 },
                        { key: 'tipoZona', name: 'Tipo zona', editable: false, dragable: false, width: 70 },
                        { key: 'fechaFra', name: 'Fecha fra.', editable: false, dragable: false, type: 'date', width: 80 },
                        { key: 'factura', name: 'Factura', editable: false, dragable: false, width: 80 },
                        { key: 'cliente', name: 'Cliente', editable: false, dragable: false, width: 350 },
                        { key: 'importe', name: 'Importe', editable: false, dragable: false, type: 'float', width: 60 },
                    ]}
                    rows={this.state.mkt}
                    buttonEdit={false}
                    buttonDelete={false}
                    buttonNew={false}
                    enableSelection={false}
                    height={200}

                />
                <div className={classes.total}>
                    <p style={{ margin: 0 }}>Total</p>

                    <TextField
                        id="total"
                        disabled
                        value={this.state.total}
                        className={classes.input}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                        variant="outlined"
                    />
                </div>

                <div className={classes.bottomBtn}>
                    <Button variant="contained" color="secondary" className={classes.button} onClick={() => { this.props.hideDialog() }}>Atrás</Button>
                </div>
            </div>
        );
    }
}


CierreSemanalResumenMKT.propTypes = {
    //state
    centroDiaSelected: PropTypes.object.isRequired,
    user: PropTypes.object,
    //dispatch
    hideDialog: PropTypes.func.isRequired
    //parameters


};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        user: state.oidc.user
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        hideDialog,
    }, dispatch);
}


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreSemanalResumenMKT));